import { constants as config } from '@config';

import { isDataURL } from '../../../../helpers/dataUrl';
import ImagesFactory from '../../../factory/images';
import humps from '../../../utils/humps';

import ElementSetter from './abstract/element';
import ImageSetter from './image';

module.exports = BackgroundSetter;

function BackgroundSetter () {
  this.handledAttributes = ['color', 'source', 'image_opacity', 'base_64', 'flipped'];
}

BackgroundSetter.prototype = new ElementSetter();
BackgroundSetter.prototype.constructor = BackgroundSetter;

BackgroundSetter.prototype.set = function (data) {
  _.each(data, function (value, attributeName) {
    if (_.contains(this.handledAttributes, attributeName)) {
      const updateMethod = humps.camelize('update_' + attributeName);
      this[updateMethod](data);
    } else if (attributeName == 'smart_asset') {
      const $backgroundElement = data.source ? this._findImageElement() : this._findColorElement();

      $backgroundElement && this.updateSmartAsset($backgroundElement, data);
    }
  }, this);
};

BackgroundSetter.prototype.updateBase64 = function (data) {
  data.source = data.base_64;
  data.from_base_64 = false;
  data.smart_load = false;
  this.updateSource(data);
};

BackgroundSetter.prototype._findImageElement = function () {
  return $('#svgcontent').children('g.background').find('image')?.get(0);
};

BackgroundSetter.prototype._findColorElement = function () {
  return $(`svg > g.background #${config.background.color}`)?.get(0);
};

BackgroundSetter.prototype.updateSource = function (data) {
  this.backgroundSourceLoaded = false;
  if (data.source.url) this._sanitizeSourceUrl(data);

  const isDataSource = _.isString(data.source) &&
    typeof data.from_base_64 === 'undefined' &&
    isDataURL(data.source);

  if (isDataSource) data.from_base_64 = true;
  if (data.source.base_64) this._sanitizeSourceBase64(data);

  data.external = this.isExternal(data);
  if (data.external && data.originalSrc) {
    data.source = data.originalSrc;
  }
  const $backgroundImage = $('#svgcontent').children('g.background').find('image');

  this.lastSource = data.source = INKIVE.Helpers.getCORSSecureUrl(data.source);

  if ($backgroundImage.length && INKIVE.ImagesFactory.getImageUrl($backgroundImage[0]) === null) {
    INKIVE.ImagesFactory.setImageUrl($backgroundImage.get(0), data.source);
    this.backgroundSourceLoaded = true;
    this._triggerSourceEvent($backgroundImage.attr('id'), data);
  } else {
    if ($backgroundImage.attr('xlink:href') === data.source ||
      $backgroundImage.attr('data-original-href') === data.source
    ) {
      return;
    }
    data.attrs || $backgroundImage.removeAttr('class');

    this._loadLowResolutionBackground($backgroundImage[0], data)
      .then((element) => {
        data.is_initial_load || this._triggerSourceEvent(element.getAttribute('id'), data, 'updating_source');

        if (data.external_source === INKIVE.C.SHUTTERSTOCK) {
          this.processSstkProBackground(data, element);
          return;
        }

        data.external && this.resizeExternalPhoto(element, data);
        data.external || this.onVersionData(element, data);
      });
  }
};

BackgroundSetter.prototype._sanitizeSourceUrl = function (data) {
  data.source = data.source.url;
  data.smart_load = data.source.smart_load;
};

BackgroundSetter.prototype._sanitizeSourceBase64 = function (data) {
  data.base_64 = data.source.base_64;
  data.source = data.source.base_64;
  data.smart_load = false;
};

BackgroundSetter.prototype.onVersionData = function (element, data) {
  if (!this._isSameBackground(data)) return;
  this.cancelImageLoading = false;
  const useSmartResize = typeof data.smart_load === 'undefined'
    ? true
    : data.smart_load;

  const size = this._getBackgroundSize(data.attrs);
  const cancelLoading = _.bind(function () { this.cancelImageLoading = true; }, this);
  // INKIVE.DesignFacade.on('delete', cancelLoading);
  data.filter = $(element).attr('filter');

  ImagesFactory.smartLoad(data.source, { width: size.width, height: size.height, skipOverride: true }, _.bind(function (status, image) {
    INKIVE.DesignFacade.off('delete', cancelLoading);

    if (!this._isSameBackground(data) || this.cancelImageLoading) {
      return;
    }

    this.lastSource = data.source = status === INKIVE.C.Status.success
      ? image.src
      : data.source;

    $(element).removeClass('resizing');
    let newElement;

    if (useSmartResize || !element) {
      const backgroundSize = this._getBackgroundSize(image);
      data.attrs = {
        ...data.attrs,
        x: (this.canvas.contentW - backgroundSize.width) / 2,
        y: (this.canvas.contentH - backgroundSize.height) / 2,
        width: backgroundSize.width,
        height: backgroundSize.height
      };

      newElement = this._createImageBackground(data);
      useSmartResize && this.updateResolution(newElement, data);
    } else {
      this.backgroundSourceLoaded = true;
      const secureUrl = INKIVE.Helpers.getCORSSecureUrl(data.source);
      const flippedProperties = data.previous_image_flipped
        ? data.previous_image_flipped
        : INKIVE.DesignFacade.get('background').flipped;

      if (flippedProperties && (flippedProperties.horizontal || flippedProperties.vertical)) {
        this.updateFlipped({ flipped: flippedProperties }, secureUrl);
      } else {
        svgedit.utilities.assignAttributes(element, {
          'xlink:href': secureUrl
        });
      }
    }

    this.updateImageOpacity(data, element);
    this.updateFilter(data, newElement);
    this.updateBackgroundRemoved(data);

    data.base_64 &&
    !data.from_base_64 &&
    INKIVE.ImagesFactory.setImageUrl(this._findImageElement(), null);

    this.backgroundSourceLoaded && this._triggerSourceEvent(element.getAttribute('id'), data);
  }, this), data.external || data.background_removed);
};

BackgroundSetter.prototype._createImageBackground = function (data) {
  const selectedElement = this.canvas.getSelectedElems();
  const hasBackgroundSelected = _.any(selectedElement, function (el) {
    return $(el).parent().is('.background');
  });

  const element = this.canvas.addElement('background', {
    type: 'image',
    data: data.source,
    smart_asset: data.smart_asset,
    custom_placeholder: data.custom_placeholder,
    attrs: data.attrs,
    old_image_id: data.old_image_id
  });

  hasBackgroundSelected && this.canvas.selectOnly([element]);

  this._preloadBackgroundImage(data).then(_.bind(function (image) {
    if (!this._isSameBackground(data)) return;

    if (!data.attrs) {
      const size = this._getBackgroundSize(image);
      data.attrs = {
        x: (this.canvas.contentW - size.width) / 2,
        y: (this.canvas.contentH - size.height) / 2,
        width: size.width,
        height: size.height
      };
    }

    element.setAttribute('x', data.attrs.x);
    element.setAttribute('y', data.attrs.y);
    element.setAttribute('width', data.attrs.width);
    element.setAttribute('height', data.attrs.height);
  }, this));

  return element;
};

BackgroundSetter.prototype.updateColor = function (data) {
  this.editor.replaceBackground({
    type: 'color',
    data: data.color,
    smart_asset: data.smart_asset
  });

  this.trigger('color', null, { color: data.color, smart_asset: data.smart_asset });
};

BackgroundSetter.prototype.updateResolution = function (element, data) {
  ImagesFactory.smartLoad(data.source, this._getBackgroundSize(),
    _.bind(function (status, optimusImage) {
      if (this._isSameBackground(data) && status === INKIVE.C.Status.success) {
        this.lastSource = data.source = optimusImage.src;
        const secureUrl = INKIVE.Helpers.getCORSSecureUrl(data.source);
        const flippedProperties = data.previous_image_flipped
          ? data.previous_image_flipped
          : INKIVE.DesignFacade.get('background').flipped;

        if (flippedProperties && (flippedProperties.horizontal || flippedProperties.vertical)) {
          this.updateFlipped({ flipped: flippedProperties }, secureUrl);
        } else {
          svgedit.utilities.assignAttributes(element, {
            'xlink:href': secureUrl
          });
        }

        this.backgroundSourceLoaded = true;

        data.from_base_64 && INKIVE.ImagesFactory.setImageUrl(element, null);
        this._triggerSourceEvent(element.id, data);
      }
    }, this), data.external
  );
};

BackgroundSetter.prototype.updateImageOpacity = function (data, element) {
  if (typeof data.image_opacity !== 'undefined') {
    element = element || $('g.background image').get(0);
    element && svgedit.utilities.assignAttributes(element, {
      opacity: data.image_opacity
    });
  }
};

BackgroundSetter.prototype.updateFilter = function (data, element) {
  const backgroundImage = $('g.background image');
  const filterDefs = $('#svgcontent').find('filter').is(`[id=\'filter_${config.background.image}\']`);
  const backgroundId = backgroundImage.attr('id');

  element = element || backgroundImage[0];

  if (data.filter) {
    $(element).attr('filter', data.filter);
  } else if (filterDefs) {
    $(element).attr('filter', 'url(#filter_' + backgroundId + ')');
  }
};

BackgroundSetter.prototype.updateBackgroundRemoved = function (data) {
  const backgroundImage = document.querySelector('g.background image');
  if (backgroundImage) {
    data.background_removed
      ? backgroundImage.setAttribute('data-background-removed', 'true')
      : backgroundImage.removeAttribute('data-background-removed');
  }
};

BackgroundSetter.prototype.updateFlipped = function (data, url) {
  const element = $('g.background image').get(0);

  this.canvas.setFlipImage(element.id, data.flipped, url);
  this.trigger('flipped', element.getAttribute('id'), data);
};

BackgroundSetter.prototype._triggerSourceEvent = function (id, data, eventName) {
  eventName = eventName || 'source';
  const backgroundObject = {
    id,
    source: !isDataURL(data.source) && data.source,
    just_added: data.just_added
  };

  this.trigger(eventName, null, backgroundObject);

  if (!data.is_initial_load && this.backgroundSourceLoaded) {
    const oldId = data.old_image_id;

    if (oldId) {
      const originalUrl = INKIVE.ImagesFactory.getImageUrl(oldId, data.source);
      originalUrl && INKIVE.ImagesFactory.setImageUrl($('#' + id).get(0), originalUrl);
    }

    this.trigger('source.loaded', null, backgroundObject);
  }
};

BackgroundSetter.prototype._isSameBackground = function (data) {
  return this.lastSource === data.source;
};

BackgroundSetter.prototype._preloadBackgroundImage = function (data) {
  const image = new Image();
  const deferred = $.Deferred();

  image.src = INKIVE.Helpers.getCORSSecureUrl(data.source);
  image.onload = _.bind(onImageLoaded, this);
  return deferred.promise();

  function onImageLoaded () {
    deferred.resolve(image);
    this.updateFilter(data);
  }
};

BackgroundSetter.prototype._getBackgroundSize = function (image) {
  const bleed = this._getBleed();
  let contentW = this.canvas.contentW;
  let contentH = this.canvas.contentH;

  if (bleed) {
    contentW += bleed.left + bleed.right;
    contentH += bleed.top + bleed.bottom;
  }

  if (!image) {
    return {
      width: contentW,
      height: contentH
    };
  }

  const aspectW = contentW / image.width;
  const aspectH = contentH / image.height;

  return aspectW > aspectH
    ? {
        width: contentW,
        height: image.height * aspectW
      }
    : {
        height: contentH,
        width: image.width * aspectH
      };
};

BackgroundSetter.prototype.isExternal = function (data) {
  return ImageSetter.prototype.isExternal.call(this, {
    source: { url: data.source }
  });
};

BackgroundSetter.prototype.resizeExternalPhoto = function (element, data) {
  this._preloadBackgroundImage(data).then(_.bind(function (image) {
    const neededSize = getNeededSize.call(this);
    const params = {
      book_id: INKIVE.C.BOOK.id,
      photo_url: ImagesFactory.getOriginalUrl(data.source) || data.source,
      platform: neededSize
    };

    const url = INKIVE.C.BASE_URL + 'inkive/resizeexternalsearchphoto';

    $(element).addClass('resizing');
    this.trigger('resize_external', element.getAttribute('id'));

    const doPost = _.bind(function () {
      $.api(url, 'POST', params, _.bind(function (result) {
        if (!this._isSameBackground(data)) return;

        if (result.STATUS === 'success') {
          const imageData = {
            thumb: result.MESSAGE.replace('/' + neededSize + '/', '/thumb/'),
            mobile: result.MESSAGE.replace('/' + neededSize + '/', '/mobile/'),
            tab: result.MESSAGE.replace('/' + neededSize + '/', '/tab/'),
            web: result.MESSAGE.replace('/' + neededSize + '/', '/web/'),
            largeweb: result.MESSAGE.replace('/' + neededSize + '/', '/largeweb/'),
            original: result.MESSAGE.replace('/' + neededSize + '/', '/original/')
          };

          this.lastSource = data.source = result.MESSAGE;
          ImagesFactory.addImageData(imageData, ImagesFactory.defaultAmazonDataNames);
        }

        this.onVersionData(element, data);
      }, this));
    }, this);

    if (data.ab_id) {
      ImagesFactory.getExternalPhotoById(
        {
          id: data.ab_id,
          type: 'ab'
        },
        function (imgUrl) {
          params.photo_url = imgUrl;
          doPost();
        }
      );
    } else {
      doPost();
    }

    function getNeededSize () {
      const size = this._getBackgroundSize(image);
      const fakedUrl = 'https://static.desygner.com/thumb/';
      const fakedRightSizeUrl = ImagesFactory.getRightSizeUrl(fakedUrl, size);
      let neededSize = _.last(_.compact(fakedRightSizeUrl.split('/'))) || 'web';

      if (neededSize === 'thumb') neededSize = 'mobile';
      if (neededSize === 'original') neededSize = 'largeweb';

      return neededSize;
    }
  }, this));
};

BackgroundSetter.prototype._loadLowResolutionBackground = function (element, data) {
  const image = new Image();
  const thumb = ImagesFactory.getVersionUrl(data.source, 'thumb');
  const deferred = $.Deferred();
  const filterAttribute = data.previous_image_filter;

  if (element && _.isNumber($(element).attr('opacity')) && $(element).attr('opacity') < 0.2) {
    $(element).attr('opacity', 1);
  }

  element = element || this.canvas.addElement('background', {
    type: 'image',
    data: thumb,
    attrs: data.attrs
  });

  image.src = thumb;
  image.onload = _.bind(onImageLoaded, this);
  image.onerror = _.bind(deferred.resolve, deferred, element);

  function onImageLoaded () {
    if (!data.attrs) {
      const size = this._getBackgroundSize(image);

      data.attrs = {
        x: (this.canvas.contentW - size.width) / 2,
        y: (this.canvas.contentH - size.height) / 2,
        width: size.width,
        height: size.height,
        filter: filterAttribute
      };
    }

    const backgroundImage = this._findImageElement();
    if (backgroundImage) {
      const secureUrl = INKIVE.Helpers.getCORSSecureUrl(thumb);
      const flippedProperties = data.previous_image_flipped
        ? data.previous_image_flipped
        : INKIVE.DesignFacade.get('background').flipped;

      if (flippedProperties && (flippedProperties.horizontal || flippedProperties.vertical)) {
        this.updateFlipped({ flipped: flippedProperties }, secureUrl);
      } else {
        svgedit.utilities.assignAttributes(backgroundImage, {
          'xlink:href': secureUrl
        });
      }

      backgroundImage.setAttribute('x', data.attrs.x);
      backgroundImage.setAttribute('y', data.attrs.y);
      backgroundImage.setAttribute('width', data.attrs.width);
      backgroundImage.setAttribute('height', data.attrs.height);

      data.previous_image_filter && backgroundImage.setAttribute('filter', data.attrs.filter);
    }

    deferred.resolve(element);
  }

  return deferred.promise();
};

BackgroundSetter.prototype._getBleed = function () {
  const bleed = this.canvas.runExtensions('getBleedValues');

  if (bleed.present) {
    const toPx = INKIVE.Helpers.convertUnitsToPixels;

    return {
      left: toPx(bleed.left, bleed.units),
      right: toPx(bleed.right, bleed.units),
      top: toPx(bleed.top, bleed.units),
      bottom: toPx(bleed.bottom, bleed.units)
    };
  }
};

BackgroundSetter.prototype.processSstkProBackground = function (data) {
  data.subscription_image
    ? INKIVE.DesygnerApi.post('payment/gateway/stripe/process', data.subscription_image).then((processData) => {
      processData.info
        ? INKIVE.EditorFacade.handle('shopping_cart', 'on_payment', { elementId: 'background', ...processData })
        : finishProcessing();
    })
    : INKIVE.DesignFacade.once('image.create.source.url', finishProcessing);

  function finishProcessing () {
    INKIVE.DesignFacade.trigger('background.update.source');
    svgedit.select.getSelectorManager().releaseAllSelectors();
  }
};
